<style lang="scss" scoped>
    /deep/ .listTable table{
        width: 100% !important;
    }
    /deep/ .listTable table tr th{
        text-align: center !important;
    }
    /deep/ .listTable table tr td{
        text-align: center !important;
    }
    /deep/ .fp-choose .ivu-radio-wrapper{
        border-radius: 4px 4px 4px 4px !important;
    }
    /deep/ .fp-choose .ivu-radio-wrapper-checked{
        background: #2d8cf0 !important;
        color: #fff !important;
    }
    .table {
        width: 100%;
        border-spacing: 0px 10px;
        &:before {
            display: none !important;
        }
    }
</style>
<template>
    <div>
        <div class="overHidden">
            <span class="fLeft font16">量程：<span class="colorPrimary">{{val}}</span></span>
            <div class="displayIB fRight">
                <span>刷新时间: {{lodeTime}}</span>
                <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
            </div>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr class="textC">
                <th v-for="(tab,$index) in list" :key="$index" class="textC">
                    <span class="ivu-table-cell">{{tab.pointName}}({{tab.unit}})</span>
                </th>
            </tr>
            <tr class="textC">
                <th v-for="(tab,$index) in list" :key="$index" class="textC">
                    <span class="ivu-table-cell">{{tab.value}}</span>
                </th>
            </tr>
        </table>
        <div class="textRight m-t-20">
            <span class="fLeft lh32 m-r-30 font16">压力监测</span>
            <Col span="5">
                <RadioGroup v-model="day" @on-change="changeTime" type="button" class="fp-choose">
                    <Radio label="today" class="m-r-10">今日</Radio>
                    <Radio label="yesterday">昨日</Radio>
                </RadioGroup>
            </Col>
            <RadioGroup v-model="type" type="button" class="fp-choose">
                <Radio label="chart" class="m-r-10">图表</Radio>
                <Radio label="table">数据</Radio>
            </RadioGroup>
        </div>
        <line-chart class="m-t-20" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x" v-show="type == 'chart'"></line-chart>
        <privateTable @sizeChange="sizeChange" class="m-t-20 m-b-40" :columnsList="tableColumns1" :dataTable="dataTable"
                       @getPageData="getPageData" v-show="type == 'table'" pageHide="true" :height="268"></privateTable>

        <div class="m-t-10">
            <span class="font16">极值统计</span>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr  v-for="(val, index) in loadValue" :key="index">
                <th>
                    <span class="ivu-table-cell">最大{{val.name}}：{{val.maxValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间：{{val.maxTime}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">最小{{val.name}}：{{val.minValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间：{{val.minTime}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
    import privateTable from '../wit-electric-monitor/private-table.vue';
    // 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'fp-pressure',
        props: {
            id: ''
        },
        data() {
            return {
                loginData: {},
                day: 'today',
                type: 'chart',
                lineData: {
                    x: [],
                    y: []
                },
                lodeTime: '',
                val: '',
                list: [],
                li: [],
                dataTable: {},
                loadValue: [],
                tableColumns1: [],
                page: {
                    totalCount: 0,
                    pageSize: 10,
                    currentPage: 1
                },
            };
        },
        mounted() {
            this.getList();
             this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
            //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            getList() {
                this.refresh();
                this.getTable();
                this.getChart();
                this.getData();
                this.getDetail();
            },
            changeTime(){
                this.getChart();
                this.getData();
            },
            sizeChange(val) {
                this.page.pageSize = val;
                this.getData();
            },//每页条数
            getPageData(val) {
                this.page.currentPage = val;
                this.getData();
            },//分页页数
            refresh() {
                this.lodeTime = getDate(new Date().getTime(), 'year');
                this.getTable();
            },
            getChart() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'yl',
                            date:this.day
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            // var sumData = [];
                            let arrX = [], arrY = {}, index = 0;
                            for (let item in res.data.data) {
                                let obj = res.data.data[item];
                                // sumData = sumData.concat(obj)
                                for (let y = 0; y < obj.length; y++) {
                                    if (index === 0) arrX.push(obj[y]['time'].substring(0,obj[y]['time'].length-2) + "00"); //秒数置为“00”
                                    if (arrY[item] && arrY[item].length) {
                                        arrY[item].push(obj[y]['value'])
                                    } else {
                                        arrY[item] = [obj[y]['value']];
                                    }
                                }
                                if (arrX.length) index = 1;
                            }
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = arrY;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getData() {
                let params = {
                    type: 'yl',
                    date:this.day
                };
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/data/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'yl',
                            date:this.day
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            function compare (prop) {
                                return function (obj1, obj2) {
                                    var val1 = obj1[prop];
                                    var val2 = obj2[prop];
                                    if (val1 > val2) {
                                        return -1;
                                    } else if (val1 < val2) {
                                        return 1;
                                    } else {
                                        return 0;
                                    }            
                                } 
                            }
                            res.data = res.data.data.sort(compare('时间'));
                            res.data.map((value,index) => {
                                if(index == 0){
                                    this.tableColumns1 = [];
                                    let newValue =  JSON.parse(JSON.stringify(value));
                                    let arr = [];
                                    ["时间", "正风压1Pa/m", "正风压1", "正风压2","负风压1", "负风压2"].forEach(key=>{
                                        if (newValue.hasOwnProperty(key)) {
                                            arr.push({title: key, key: key})
                                            delete newValue[key]
                                        }
                                    })
                                    for (let i in newValue) {
                                        arr.push({
                                            title: i,
                                            key: i
                                        })
                                    }
                                    this.tableColumns1 = arr;
                                    console.log(this.tableColumns1);
                                    
                                }
                            })
                            this.li = res.data;
                            this.page.totalCount = res.totalCount ? res.totalCount : res.data.length;
                            this.dataTable = {
                                list: this.li,
                                page: this.page,
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'yl',
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            if(res.data.data.length > 0){
                                this.val = res.data.data[0].ranges;
                                this.list = res.data.data;
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getDetail() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/loadValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'yl',
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            this.loadValue = res.data.data;
                            this.loadValue.forEach(function(value) {
                                value.maxTime != '~' ? value.maxTime = getDate(parseInt(value.maxTime), 'year') : value.maxTime = '~';
                                value.minTime != '~' ? value.minTime = getDate(parseInt(value.minTime), 'year') : value.minTime = '~';
                            });
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
        },
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart,
            privateTable
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/fp/fp-pressure.vue